import React from 'react'
import { ExtendStayBooking } from '@/hooks/useExtendStayBooking'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import TripActivity from '../TripActivity'

export default function TripActivityModule({
  extendData
}: {
  extendData: ExtendStayBooking | null
}) {
  return !extendData ? (
    <TripActivity
      productType={['STAY', 'FLY', 'DRIVE']}
      analyticsCategory={ANALYTICS_CATEGORY_HOME}
    />
  ) : null
}
